
import { Vue, Component } from "vue-property-decorator";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";

@Component
export default class Home extends Vue {
  dataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "news",
  });

  get caption(){
    return this.dataSource.model?.userConsent?.userProfile?.fullName;
  }
  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Заявки для отмены согласия",
        to: "/manage/user-consent-cancellation/",
        exact: true,
      },
      {
        text: this.caption,
        disabled: true,
      },
    ];
  }
}
